import { useState } from 'react';
import ErrorSessionDetailModal from './ErrorSessionDetailModal';
import {
  CHART_COLORS,
  formatDuration,
  formatPercent,
  getErrorTypeLabel,
} from './dashboardSummaryUtils';
import styles from './DashboardSummaryCards.module.scss';

function ErrorTypeShareCard({ errorData, machines = [], scope = null, loading = false }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalInitialErrorType, setModalInitialErrorType] = useState(null);

  if (loading) {
    return (
      <div className={styles.summaryPanel}>
        <div className={styles.loadingMessage}>Loading error type share...</div>
      </div>
    );
  }

  const totalErrorMinutes = errorData?.total_minutes || 0;
  const errorTypeSummary = [...(errorData?.error_type_summary || [])].sort(
    (a, b) => b.total_minutes - a.total_minutes
  );
  const topErrorTypes = errorTypeSummary.slice(0, 5);
  const hiddenErrorTypesCount = Math.max(errorTypeSummary.length - topErrorTypes.length, 0);

  const openModal = errorType => {
    setModalInitialErrorType(errorType);
    setModalOpen(true);
  };

  return (
    <div className={styles.summaryPanel}>
      <div className={styles.panelHeader}>
        <h3 className={styles.panelTitle}>
          Error Type Share
          <span className={styles.panelSubtitle}>
            {`Total downtime · ${formatDuration(totalErrorMinutes)}`}
          </span>
        </h3>
        <button type="button" className={styles.moreLink} onClick={() => openModal(null)}>
          More...
        </button>
      </div>
      <p className={styles.chartSubtitle}>
        Compare how total downtime is distributed across the highest-impact error types.
      </p>
      {topErrorTypes.length > 0 ? (
        <div className={styles.errorBars}>
          {topErrorTypes.map((item, index) => {
            const share = totalErrorMinutes > 0 ? item.total_minutes / totalErrorMinutes : 0;

            return (
              <button
                key={item.error_type}
                type="button"
                className={styles.errorBarButton}
                onClick={() => openModal(item.error_type)}
              >
                <div className={styles.errorBarHeader}>
                  <span className={styles.errorBarLabel}>{getErrorTypeLabel(item.error_type)}</span>
                  <span className={styles.errorBarDuration}>
                    {formatDuration(item.total_minutes)}
                  </span>
                </div>
                <div className={styles.errorBarTrack}>
                  <div
                    className={styles.errorBarFill}
                    style={{
                      width: `${Math.max(share * 100, share > 0 ? 4 : 0)}%`,
                      backgroundColor: CHART_COLORS[index % CHART_COLORS.length],
                    }}
                  />
                </div>
                <div className={styles.errorBarMeta}>
                  <span>{formatPercent(share)}</span>
                  <span className={styles.errorBarCode}>{item.error_type}</span>
                </div>
              </button>
            );
          })}
          {hiddenErrorTypesCount > 0 && (
            <div className={styles.chartFootnote}>
              {`+${hiddenErrorTypesCount} more error types available in More...`}
            </div>
          )}
        </div>
      ) : (
        <div className={styles.noData}>No error sessions</div>
      )}

      {modalOpen && (
        <ErrorSessionDetailModal
          machines={machines}
          scope={scope}
          initialDate={null}
          initialErrorType={modalInitialErrorType}
          onClose={() => setModalOpen(false)}
        />
      )}
    </div>
  );
}

export default ErrorTypeShareCard;
